import { useEffect, useRef, useState } from 'react';
import { FieldChangeCallback } from '@sitecore-jss/sitecore-jss-react-forms';

import { usePrefill } from '../contexts/PrefillContext';

export function usePrefillableValue(
  controlName: string,
  initialValue: string,
  onChange: FieldChangeCallback,
  fieldName: string
): [string, React.Dispatch<React.SetStateAction<string>>] {
  const prefillValue = usePrefill(controlName);
  const [value, setValue] = useState(initialValue);
  const prefillApplied = useRef(false);

  useEffect(() => {
    if (prefillValue !== undefined && !prefillApplied.current) {
      prefillApplied.current = true;
      setValue(prefillValue);
      onChange(fieldName, prefillValue, true, []);
    }
  }, [prefillValue, onChange, fieldName]);

  return [value, setValue];
}
